import axios from 'axios';

import type { PostRequest, PostSellerCommunicationSendEmailsResult } from './request';

export type PostSellerCommunicationSendEmailsClientApiCall = (
	data: PostRequest['body'],
) => Promise<PostSellerCommunicationSendEmailsResult>;

const SELLER_COMMUNICATIONS_SEND_EMAILS_CLIENT_ENDPOINT = '/api/seller-communications/send-emails';

export const postSellerCommunicationSendEmails: PostSellerCommunicationSendEmailsClientApiCall = async (data) => {
	const res = await axios.post(SELLER_COMMUNICATIONS_SEND_EMAILS_CLIENT_ENDPOINT, data);
	return res.data as ReturnType<PostSellerCommunicationSendEmailsClientApiCall>;
};
